/**
 * 本地选项占位 ID（A/B/C…），与后端 Hashid 区分：后者通常 ≥5 位且可含数字。
 */
export function isLocalLetterOptionId(id: string | undefined | null): boolean {
  const t = (id ?? '').trim();
  if (t === '') return true;
  return /^[A-Z]{1,4}$/.test(t);
}

/**
 * 选项 ID：1→A, 2→B …（与 Vue 版一致）
 */
export function numberToLetterId(num: number): string {
  if (num <= 0) return 'A';
  let result = '';
  let n = num - 1;
  while (n >= 0) {
    result = String.fromCharCode(65 + (n % 26)) + result;
    n = Math.floor(n / 26) - 1;
  }
  return result;
}
